import React, { useState, useEffect } from "react";
import "./FileInput.css";
import { useDropzone } from "react-dropzone";
import uploadIcon from "../../assets/Icons/PNG/upload.png";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Joi from "joi";

const MAXSIZE = 25 * 1024 * 1024;

export function FileInput({
  uploadedFilesNames,
  onUploadFile,
  onRemoveFile,
  numOfFiles,
  askForUplaodText = "Drag and drop your file or click to upload",
  disabled = false,
  maxSize = MAXSIZE,
  isRequired,
}) {
  const [errorMessage, setErrorMessage] = useState();
  useEffect(() => {
    if (disabled) {
      setErrorMessage("");
    }
    else if (isRequired && !uploadedFilesNames?.length) {
      setErrorMessage("Please upload at least one file.");
    } else {
      setErrorMessage("");
    }
  }, [isRequired, uploadedFilesNames, disabled]);
  
  const fileSchema = Joi.object({
    FileName: Joi.string()
      .required()
      .messages({ "string.pattern.base": "File type is invalid." }),
    FileSize: Joi.number()
      .max(maxSize)
      .messages({
        "number.max": `File size is too large. Maximum allowed size is ${
          maxSize / (1024 * 1024)
        } MB.`,
      }),
    ContentType: Joi.string()
      .required()
      .messages({ "string.empty": "Content type is required." }),
    FileDate: Joi.any().required().messages({
      "binary.base": "File data is invalid.",
      "any.required": "File data is required.",
    }),
  });

  const onLoadEnd = (reader, file) => {
    const fileDate = new Uint8Array(reader.result);
    const fileObjForValidation = {
      FileName: file.name,
      FileSize: file.size,
      ContentType: file.type,
      FileDate: fileDate,
    };
    const validationResult = fileSchema.validate(fileObjForValidation);

    if (validationResult.error)
      setErrorMessage(validationResult?.error?.details?.at(0)?.message);
    else {
      setErrorMessage("");
      onUploadFile(file);
    }
  };

  const onDropAccepted = (acceptedFiles) => {
    const accepted = numOfFiles
      ? acceptedFiles.slice(0, numOfFiles)
      : acceptedFiles;
    accepted.forEach((file) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = () => onLoadEnd(reader, file);
    });
  };

  const validateUploadedFile = (file) => {
    const isDisallowedFile = file.name.match(
      /\.(exe|xlsx|bat|cmd|com|cpl|js|jse|msi|msp|pif|scr|vbs|wsf)$/i
    );

    if (isDisallowedFile) {
      setErrorMessage(`The extension of file "${file.name}" is not accepted.`);
      return true;
    }

    return false;
  };

  const { getRootProps, getInputProps } = useDropzone({
    disabled: disabled,
    accept: {},
    validator: validateUploadedFile,
    onDropAccepted: onDropAccepted,
  });

  const removeFile = (e, index) => {
    onRemoveFile(index);
    e.stopPropagation();
  };

  return (
    <div>
      <Row>
        <Col>
          <div id="uploadedFiles" className="file-input">
            <label className="mt-2">Attachment(s)</label>
            <div
              {...getRootProps()}
              className={
                disabled
                  ? "file-input-container cursor-not-allowed"
                  : "file-input-container"
              }
              id="dropzone-input"
            >
              <input {...getInputProps()} />
              <img src={uploadIcon} alt="Upload Icon" />
              {uploadedFilesNames?.length > 0 &&
                uploadedFilesNames?.map((name, index) => (
                  <p key={index} className="upload-text">
                    <span
                      onClick={(e) => removeFile(e, index)}
                      className="remove-icon"
                    >
                      x
                    </span>
                    {`${name} uploaded successfully`}
                  </p>
                ))}
              {!uploadedFilesNames?.length && (
                <p className="upload-text">{askForUplaodText}</p>
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row>{errorMessage && <p className="error" id="file-erroe-message">{errorMessage}</p>}</Row>
    </div>
  );
}
